import React from 'react';
import Logo from '../../UI/Logo/Logo';
import Apps from '../../UI/Apps/Apps';
import ToolbarItems from './ToolbarItems';
import './Toolbar.css';

function Toolbar() {
  return (
    <div className='toolbar-nav'>
      <Logo />
      <ToolbarItems />
      <Apps />
    </div>
  );
}

export default Toolbar;
